export default "__VITE_ASSET__Byn8g9Yk__"